// extracted by mini-css-extract-plugin
module.exports = {"textStyling":"ErrorBoundary_textStyling__Fj8bD","errorImageStyle":"ErrorBoundary_errorImageStyle__1CAOL","logoStyling":"ErrorBoundary_logoStyling__2N3rj"};